<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { CloseIcon } from '@solar-icons/vue/linear'
import AppDockPanel from '../../primitives/AppDockPanel/AppDockPanel.vue'
import AppButton from '../../primitives/AppButton/AppButton.vue'
import AppConversation from '../AppConversation/AppConversation.vue'
import { useChatDock } from './useChatDock'

const props = withDefaults(
  defineProps<{
    label?: string
    empty?: boolean
    /** Identifies the active thread; changing it re-pins the viewport to the bottom. */
    threadKey?: string | null
  }>(),
  {
    label: undefined,
    empty: false,
    threadKey: null,
  },
)

const { closeDock } = useChatDock()
const { t } = useI18n()

const resolvedLabel = computed(() => props.label ?? t('chat.dock.label'))
</script>

<template>
  <AppDockPanel :label="resolvedLabel">
    <template #header-actions>
      <slot name="header-actions" />
      <AppButton
        size="sm"
        icon-only
        variant="ghost-strong"
        :start-icon="CloseIcon"
        :aria-label="t('chat.dock.close')"
        @click="closeDock"
      />
    </template>

    <AppConversation
      :is-empty="empty"
      :log-label="resolvedLabel"
      :scroll-to-bottom-label="t('chat.scrollToBottom')"
      :thread-key="threadKey"
      class="min-h-0 flex-1"
    >
      <slot />
      <template #empty><slot name="empty" /></template>
      <template v-if="$slots.composer" #composer><slot name="composer" /></template>
    </AppConversation>
  </AppDockPanel>
</template>
